import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
//declare function ire(string,{}): any;

@Component({
  selector: 'app-case-study',
  templateUrl: './case-study.component.html',
  styleUrls: ['./case-study.component.scss']
})
export class CaseStudyComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Trinkaの事例紹介 – AI英文校正Trinka');
    this.metaTagService.updateTag({ name: 'description', content: "Trinka（トリンカ）が世界の教育機関、出版社、組織・団体によるアカデミック・ライティングの執筆から発表までの行程をどのようにお手伝いしてきたか、事例の一部をご紹介します。" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinkaの事例紹介 – AI英文校正Trinka' });
    this.metaTagService.updateTag({ property: 'og:description', content: '​Trinka（トリンカ）が世界の教育機関、出版社、組織・団体によるアカデミック・ライティングの執筆から発表までの行程をどのようにお手伝いしてきたか、事例の一部をご紹介します。​' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/case-study' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'robots', content: 'noindex, nofollow' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinkaの事例紹介 – AI英文校正Trinka' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka（トリンカ）が世界の教育機関、出版社、組織・団体によるアカデミック・ライティングの執筆から発表までの行程をどのようにお手伝いしてきたか、事例の一部をご紹介します。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/case-study' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/case-study' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/case-study' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/case-study' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/case-study' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/case-study' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/case-study' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/case-study' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/case-study' });
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }

  

}
